import React, { useState } from "react";
import { Box, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import ActionButton from "@/components/actions/ActionButton";
import { TitleTypography } from "./commonCmp";
import PieChart from "./PieChart";
import PieChartBottom from "./PieChartBottom";
import DeviceList from "./DeviceList";
import AttendanceRecord from "./AttendanceRecord";
import AttendanceStatus from "./AttendanceStatus";

const AttendanceDashboard: React.FC = () => {
  const { t } = useTranslation();
  const [pageSize, setPageSize] = useState<number>(25);
  const [page, setPage] = useState<number>(0);
  const [refresh, setRefresh] = useState<number>(0);
  const [refreshChart, setRefreshChart] = useState<number>(0);

  const refreshChartData = () => {
    setRefreshChart(refreshChart + 1);
  };

  return (
    <Box>
      {/* First Row: PieCharts + DeviceList */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          paddingRight: "14px",
          minHeight: "440px",
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
            minWidth: "500px",
            width: "65%",
            padding: "6px 6px 6px 0px",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#ffffff",
            backgroundClip: "content-box",
            minHeight: "440px",
            borderRadius: "20px !important",
          }}
        >
          <Box
            sx={{
              height: "40px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0px 8px",
              marginLeft: "5px",
            }}
          >
            <TitleTypography>{t("common.Attendance")}</TitleTypography>
            <Tooltip title={t("common.refresh")}>
              <div>
                <ActionButton
                  icon="icon-ic_refresh"
                  handleClick={refreshChartData}
                />
              </div>
            </Tooltip>
          </Box>
          <Box sx={{ flexGrow: 1 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                width: "100%",
                height: "100%",
                backgroundColor: "#ffffff",
                borderRadius: "10px",
                p: 1,
              }}
            >
              <PieChart
                refreshChart={refreshChart}
                category={"day"}
                title={t("common.Today")}
              />
              <PieChart
                refreshChart={refreshChart}
                category={"week"}
                title={t("common.This Week")}
              />
              <PieChart
                refreshChart={refreshChart}
                category={"month"}
                title={t("common.This Month")}
              />
            </Box>
          </Box>
          <Box
            sx={{
              height: "60px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <PieChartBottom refreshChart={refreshChart} />
          </Box>
        </Box>
        <Box
          sx={{
            minWidth: "300px",
            flexGrow: 1,
            width: "30%",
            padding: "6px",
            boxSizing: "border-box",
            minHeight: "440px",
            height: "calc(50vh - 20px)",
          }}
        >
          <Box
            sx={{
              backgroundColor: "#ffffff",
              height: "100%",
              borderRadius: "10px",
              p: 1,
            }}
          >
            <DeviceList />
          </Box>
        </Box>
      </Box>

      {/* Second Row: AttendanceRecord + AttendanceStatus */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          paddingRight: "14px",
          height: "calc(50vh - 20px)",
          minHeight: "440px",
          marginBottom: "14px",
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
            minWidth: "400px",
            width: "50%",
            padding: "6px 6px 6px 0px",
            boxSizing: "border-box",
            minHeight: "440px",
          }}
        >
          <Box
            sx={{
              backgroundColor: "#ffffff",
              height: "100%",
              borderRadius: "10px",
              p: 1,
            }}
          >
            <AttendanceRecord
              pageSize={pageSize}
              setPageSize={setPageSize}
              page={page}
              setPage={setPage}
              refresh={refresh}
              setRefresh={setRefresh}
            />
          </Box>
        </Box>
        <Box
          sx={{
            minWidth: "400px",
            flexGrow: 1,
            width: "50%",
            padding: "6px",
            boxSizing: "border-box",
            minHeight: "440px",
            height: "calc(50vh - 20px)",
          }}
        >
          <Box
            sx={{
              backgroundColor: "#ffffff",
              height: "100%",
              borderRadius: "10px",
              p: 1,
            }}
          >
            <AttendanceStatus
              pageSize={pageSize}
              setPageSize={setPageSize}
              page={page}
              setPage={setPage}
              refresh={refresh}
              setRefresh={setRefresh}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AttendanceDashboard;